import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetApiKeysQuery,
  GetApiKeysQueryVariables,
} from '../../../shared/generated/graphql';

export const GET_API_KEYS = gql`
  query getAPIKeys($size: Int, $offset: Int) {
    listAPIKeyDefinitions(size: $size, offset: $offset) {
      api_key_definitions {
        id
        name
        updated_ts
        created_ts
        created_by_alias
        end_ts
      }
      offset
      size
      total_count
    }
  }
`;

export const useGetAPIKeys = (
  options?: QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>,
) => {
  return useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GET_API_KEYS, {
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    ...options,
  });
};
